import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Notification } from '../NotificationLoginComponent';
import { sha512 } from 'js-sha512';
import { guessAgeTypeLabel } from './ageHint'
import './EditarUsuarioComponent.css';
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from 'react-icons/fa';
import { getActiveProfileToken } from "../../utils/profileStorage";


export const EditarUsuarioComponent = (props) => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    dni: '',
    partners: '',
    telephone: '',
    email: '',
    rewards: '',
    birthday: '',
  });
  const [errors, setErrors] = useState({});
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);
  const [isErrorNoti, setIsErrorNoti] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(
          `https://api.fallaplazarodrigo.es:999/Users/GetAccountById`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              token: getActiveProfileToken(),
            },
            body: JSON.stringify({ id: userId }),
          }
        );
        if (!res.ok) throw new Error('Error al cargar usuario');
        const data = await res.json();
        setFormData({
          name: data.name,
          surname: data.surname,
          dni: data.dni,
          partners: parseJsonOrString(data.partners),
          telephone: data.telephone?.toString() || '',
          email: data.email || '',
          rewards: parseJsonOrString(data.rewards),
          birthday: formatDate(data.birthday),
        });
      } catch (err) {
        console.error(err);
      }
    };
    fetchUser();
  }, [userId]);

  const parseJsonOrString = (input) => {
    try {
      const parsed = JSON.parse(input);
      return Array.isArray(parsed) ? parsed.join(', ') : input;
    } catch {
      return input;
    }
  };

  const formatDate = (dateString) => {
    const d = new Date(dateString);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const generatePassword = (surname, birthday) => {
    const bd = new Date(birthday);
    const day = String(bd.getDate()).padStart(2, '0');
    const month = String(bd.getMonth() + 1).padStart(2, '0');
    const year = String(bd.getFullYear()).slice(-2);
    return `${surname.slice(0, 3).toLowerCase()}${day}${month}${year}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };

  const validateForm = () => {
    const newErr = {};
    const today = new Date();

    if (!/^[a-zA-ZÀ-ÿ\s]+$/.test(formData.name))
      newErr.name = 'Nombre no válido.';
    if (!/^[a-zA-ZÀ-ÿ\s]+$/.test(formData.surname))
      newErr.surname = 'Apellido no válido.';
    if (!/^\d{8}[A-Z]$/.test(formData.dni))
      newErr.dni = 'DNI debe ser 8 dígitos y letra mayúscula.';
    if (
      formData.telephone &&
      !/^\d{9}$/.test(formData.telephone)
    )
      newErr.telephone = 'Teléfono: 9 dígitos.';
    if (
      formData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    )
      newErr.email = 'Email no válido.';
    if (new Date(formData.birthday) > today)
      newErr.birthday = 'Fecha de nacimiento futura.';

    setErrors(newErr);
    return Object.keys(newErr).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    // Preparar arrays defensivamente
    const partnersArr = Array.isArray(formData.partners)
      ? formData.partners
      : formData.partners
        ? formData.partners.toString().split(',').map((s) => s.trim())
        : [];
    const rewardsArr = Array.isArray(formData.rewards)
      ? formData.rewards
      : formData.rewards
        ? formData.rewards.toString().split(',').map((s) => s.trim())
        : [];

    // Recalcular edad, generar pass y forzar DNI mayúsculas
    const rawPass = generatePassword(formData.surname, formData.birthday);
    const hashedPass = sha512(rawPass);
    const dniUpper = formData.dni.toUpperCase();

    const payload = {
      Id: userId,
      Username: dniUpper,
      Password: hashedPass,
      Name: formData.name,
      Surname: formData.surname,
      Dni: dniUpper,
      Partners: JSON.stringify(partnersArr),
      Telephone: formData.telephone ? parseInt(formData.telephone) : null,
      Email: formData.email?.trim() || null,
      Rewards: JSON.stringify(rewardsArr),
      Birthday: formData.birthday,
    };

    try {
      const res = await fetch(
        'https://api.fallaplazarodrigo.es:999/Users/UpdateAccount',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            token: getActiveProfileToken(),
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        setNotificationMessage('Usuario actualizado con éxito');
        setIsErrorNoti(false);
        setShowNotification(true);
        setTimeout(() => navigate('/admin/administracion-usuarios'), 2500);
      } else {
        setNotificationMessage('Error al actualizar usuario');
        setIsErrorNoti(true);
        setShowNotification(true);
      }
    } catch (err) {
      console.error(err);
      setNotificationMessage('Error de red');
      setIsErrorNoti(true);
      setShowNotification(true);
    }
  };

  return (
    <div className="edit-user">
      {showNotification && (
        <Notification
          message={notificationMessage}
          type={isErrorNoti ? 'error' : 'success'}
        />
      )}

      <div className="edit-user-header">
        <button className="edit-user-back-button" onClick={() => navigate('/admin/administracion-usuarios')}>
          <FaArrowLeft className="back-icon" /> Volver
        </button>
        <h2 className="titulo-page">Editar Usuario</h2>
      </div>
      <div className="edit-user-container">
        <form className="edit-user-form" onSubmit={handleSubmit}>
          {/* Name */}
          <label className="edit-user-label">
            {props.I18n.Name}:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="edit-user-input"
            />
            {errors.name && (
              <span className="error-message">{errors.name}</span>
            )}
          </label>
          {/* Surname */}
          <label className="edit-user-label">
            {props.I18n.Surname}:
            <input
              type="text"
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              required
              className="edit-user-input"
            />
            {errors.surname && (
              <span className="error-message">{errors.surname}</span>
            )}
          </label>
          {/* DNI */}
          <label className="edit-user-label">
            {props.I18n.DNI}:
            <input
              type="text"
              name="dni"
              value={formData.dni}
              onChange={handleChange}
              required
              className="edit-user-input"
            />
            {errors.dni && (
              <span className="error-message">{errors.dni}</span>
            )}
          </label>
          {/* Partners */}
          <label className="edit-user-label">
            {props.I18n.Partners}:
            <input
              type="text"
              name="partners"
              value={formData.partners}
              onChange={handleChange}
              className="edit-user-input"
            />
          </label>
          {/* Telephone */}
          <label className="edit-user-label">
            {props.I18n.Phone}:
            <input
              type="text"
              name="telephone"
              value={formData.telephone}
              onChange={handleChange}
              className="edit-user-input"
            />
            {errors.telephone && (
              <span className="error-message">{errors.telephone}</span>
            )}
          </label>
          {/* Email */}
          <label className="edit-user-label">
            {props.I18n.Email}:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="edit-user-input"
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
          </label>
          {/* Rewards */}
          <label className="edit-user-label">
            {props.I18n.Rewards}:
            <input
              type="text"
              name="rewards"
              value={formData.rewards}
              onChange={handleChange}
              className="edit-user-input"
            />
          </label>
          {/* Birthday */}
          <label className="edit-user-label">
            {props.I18n.Birthdate}:
            <input
              type="date"
              name="birthday"
              value={formData.birthday}
              onChange={handleChange}
              required
              className="edit-user-input edit-user-date"
            />
            {errors.birthday && (
              <span className="error-message">{errors.birthday}</span>
            )}
          </label>
          {formData.birthday && (
           <div className="age-hint">
             Grupo estimado (corte 15/03): <strong>{guessAgeTypeLabel(formData.birthday)}</strong>
           </div>
         )}
          <button type="submit" className="edit-user-button">
            {props.I18n.UpdateProfile}
          </button>
        </form>
      </div>
    </div>
  );
};
